import { render, staticRenderFns } from "./16.10Record.vue?vue&type=template&id=7cba1dc8&scoped=true&"
import script from "./16.10Record.vue?vue&type=script&lang=js&"
export * from "./16.10Record.vue?vue&type=script&lang=js&"
import style0 from "./16.10Record.vue?vue&type=style&index=0&id=7cba1dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cba1dc8",
  null
  
)

export default component.exports